
            const data = {"name":"point","data":{"width":"8","height":"8","viewBox":"0 0 8 8","data":"<circle pid=\"0\" cx=\"4.143\" cy=\"4.096\" r=\"3.81\" _fill=\"#7D78A2\"/>","originalColors":[{"type":"fill","color":"#7D78A2"}],"stopColors":[]}}
        
                    module.exports = data
                    